import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Text } from '@primer/components';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Follow these guidelines to best use GitHub icons and illustrations within a presentation. Approved visual assets are provided within the `}<a parentName="p" {...{
        "href": "https://primer.style/presentations/assets"
      }}>{`asset library`}</a>{`.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Dont mdxType="Dont">
    <Text mdxType="Text">Alter the illustrations</Text>
  </Dont>
  <Dont mdxType="Dont">
    <Text mdxType="Text">Combine images that use different stylings</Text>
  </Dont>
    </DoDontContainer>
    <h2>{`Icons`}</h2>
    <p>{`Icons are used to show a visual association with different objects.`}</p>
    <img width="958" alt="Icon pairing example with community pairing with a globe, learning with a lightbulb, virtual reality with a vr headset, and blockchain with lock surrounded by connected checkboxes in a circle" src="https://user-images.githubusercontent.com/10384315/55268614-b340c480-5248-11e9-9600-03b5bb7e6073.png" />
    <h3>{`Replace icons (Keynote)`}</h3>
    {
      /*![Replacing icons in Keynote is easy!](https://user-images.githubusercontent.com/10384315/54571638-f4132080-49a0-11e9-9e4e-406ce3c44ec1.gif)*/
    }
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/55364700-93064500-5496-11e9-8dc4-cfa2a106517e.gif",
        "alt": "keynote-icon-replace"
      }}></img></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Step`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1. Open `}<a parentName="td" {...{
              "href": "/presentations/docs/assets#Marketing-icons"
            }}>{`GitHub-keynote-icons.key`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><img width="500" alt="Screenshot 2019-03-18 13 35 39" src="https://user-images.githubusercontent.com/10384315/54571249-13a94980-499f-11e9-9643-1401534922d4.png" /></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`2. Select icon and copy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55425611-c3ea8680-5537-11e9-877f-6e575e8b50a5.png",
              "alt": "choose-icon"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`3. In your presentation, select your icon layout template (1-4 icons available)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/54777536-ba742c80-4bcf-11e9-81e5-df0e518d8ad5.png",
              "alt": "Select Layout"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`4. Select the icon you would like to replace`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55426006-9baf5780-5538-11e9-961a-307bb841056e.png",
              "alt": "replace-icon-1"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`5. Paste`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/55426007-9baf5780-5538-11e9-97eb-e140fe9ef55b.png",
              "alt": "replace-icon-2"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3>{`Replace icons (Google Slides)`}</h3>
    <p><strong parentName="p">{`Step 1: Choose your icon`}</strong></p>
    <ul>
      <li parentName="ul">{`Go to `}<a parentName="li" {...{
          "href": "https://ghicons.github.com/"
        }}>{`https://ghicons.github.com/`}</a></li>
      <li parentName="ul">{`Find the icon you’d like to use`}</li>
      <li parentName="ul">{`Right click > `}<strong parentName="li">{`Copy Image Address`}</strong></li>
    </ul>
    <p><strong parentName="p">{`Step 2: Add to slide`}</strong></p>
    <ul>
      <li parentName="ul">{`On slide, click placeholder icon`}</li>
      <li parentName="ul">{`Click `}<strong parentName="li">{`Replace Image > By URL`}</strong></li>
      <li parentName="ul">{`Paste URL copied from ghicons.github.com`}</li>
    </ul>
    <h2>{`Illustrations`}</h2>
    <p>{`There is a wide variety of illustrations that are available to use for your presentation. The `}<a parentName="p" {...{
        "href": "https://octodex.github.com/"
      }}>{`Octodex`}</a>{` is full of pre-approved Octocat illustrations. If you'd like to customize your own Octocat, use the `}<a parentName="p" {...{
        "href": "https://myoctocat.com/"
      }}>{`Octocat Generator`}</a>{`.`}</p>
    <p><strong parentName="p">{`Need a specific illustration?`}</strong>{` Create an issue within the `}<a parentName="p" {...{
        "href": "https://github.com/primer/presentations/"
      }}>{`presentations repo`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      